import { SpherePlatformApp } from '@sphere/platform';
import { PATHS } from './internal-tools.paths';
import { internalToolsApp } from './internal-tools';

export const InternalToolsApp: SpherePlatformApp = {
    APP: internalToolsApp,
    PATHS
};
